import { Tracker } from 'react-tracker';
import axios from 'axios';
import * as trackingModules from './trackingModules';

class BookingFlowTracker {
    constructor(enabledTrackingModules) {
        this.enabledTrackingModules = enabledTrackingModules;
        this.tracker = new Tracker();
        this.listenEvents();
        return this;
    }

    listenEvents() {
        this.tracker.on('*', (event, eventsHistory) => {
            if (event.data.onlyOnce && eventsHistory.find(e => e.type === event.type)) {
                return null;
            }
            this.handleEvent(event.type, event.data.eventData);
            return event;
        });
    }

    handleEvent(eventName, eventData) {
        this.enabledTrackingModules.forEach((moduleParams) => {
            const TrackingModule = trackingModules[moduleParams.trackingModuleId];
            if (TrackingModule && TrackingModule.handlers[eventName]) {
                TrackingModule.handlers[eventName](eventData, { axios });
            }
        });
    }
}

export default BookingFlowTracker;
